import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import VehicleRegistration from '../../menforms/form/TitleRegistration'
// import Mayor from '../../menhome/Mayor'
// import Second from '../../menhome/Client'

function Main() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Vehicle Title & Registrations Application || Forms";
  }, [])

  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
          <Bredcom 
            subtitle="Forms"
            title="Vehicle Title & Registrations Application"
            subtitledown="Vehicle Title & Registrations Application"
           />
            <VehicleRegistration/>
            {/* <Mayor/>
            <Second/> */}
        </div>
    </>
  )
}

export default Main